<ng-container *transloco="let t">
  @if (errorCode == 'GENERAL' || errorCode == 'APP_KEY_NOT_FOUND') {
    <div class="container flex text-center justify-content-center align-items-center">
      <div class="flex flex-column text-center justify-content-center align-items-center">
        <img src="browser.png" alt="404 image" draggable="false" height="130">
        <div>
          <h1 class="mb-2">{{ t('api_error.inernal_error') }}</h1>
          <p>{{ t('api_error.page_message') }}</p>
          <p class="mb-2"><b>{{ t('api_error.error_code') }}:</b> {{ errorCode }}</p>
          @if (errorMessage) {
            <p class="mt-0"><b>{{ t('error') }}:</b> {{ errorMessage }}</p>
          }
          <p-button (onClick)="goHome()" [label]="t('back_home') | uppercase"></p-button>
        </div>
      </div>
    </div>
  } @else if (errorCode == 'PWA_SUSPENDED') {
    <div class="container flex text-center justify-content-center align-items-center">
      <div class="flex flex-column text-center justify-content-center align-items-center">
        <img src="browser.png" alt="404 image" draggable="false" height="130">
        <div>
          <h1>{{ t('api_error.pwa_suspended.title') }}</h1>
          <p [innerHTML]="t('api_error.pwa_suspended.text')"></p>
          <p-button (onClick)="openContactModal()" [label]="t('contact_us') | uppercase"></p-button>
        </div>
      </div>
    </div>
    
    <p-dialog [header]="t('contact_us')" [(visible)]="contactModalVisible" [modal]="true" [style]="{ width: '50vw' }"
      [draggable]="false" [resizable]="false" [closable]="false">
      @if (error || message) {
        <p-message [severity]="error ? 'error' : 'success'" [text]="error || message || ''" [closable]="false"></p-message>
      }
      @if (message) {
        <div class="flex text-center justify-content-center">
          <p-button [label]="t('close')" (onClick)="contactModalVisible = false"></p-button>
        </div>
      } @else {
        <form #form="ngForm" novalidate>
          <div class="mt-2">
            <div class="mt-1 w-100">
              <label class="font-semibold" for="name">{{t('form.name')}}</label>
              <input #name="ngModel" id="name" class="p-inputtext-sm w-full mt-2" placeholder="Mario" type="text" name="name"
                pInputText [(ngModel)]="contactFormModel.name" minlength="3" required />
              <div [hidden]="(name.valid || name.pristine)" class="mt-1"><span class="text-red-500">{{
                  t('form.invalid_format') }}</span>
              </div>
            </div>
            <div class="mt-1 w-100">
              <label class="font-semibold" for="surname">{{t('form.surname')}}</label>
              <input #surname="ngModel" id="surname" class="p-inputtext-sm w-full mt-2" placeholder="Rossi" type="text"
                name="surname" pInputText [(ngModel)]="contactFormModel.surname" minlength="3" required />
              <div [hidden]="(surname.valid || surname.pristine)" class="mt-1"><span class="text-red-500">{{
                  t('form.invalid_format') }}</span>
              </div>
            </div>
            <div class="mt-1 w-100">
              <label class="font-semibold" for="email">{{ t('form.email') }}</label>
              <input #email="ngModel" id="email" autocomplete="email" class="p-inputtext-sm w-full mt-2"
                placeholder="mario.rossi@gmail.com" type="text" name="email" pInputText [(ngModel)]="contactFormModel.email"
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" required />
              <div [hidden]="(email.valid || email.pristine)" class="mt-1"><span class="text-red-500">{{
                  t('form.invalid_format') }}</span>
              </div>
            </div>
            <div class="mt-3">
              <label class="font-semibold" for="message">{{ t('form.message') }}</label>
              <textarea #messageInput="ngModel" id="message" class="p-inputtext-sm w-full mt-2" type="text" name="message"
                pInputTextarea [(ngModel)]="contactFormModel.text" minlength="15" rows="4" required
                [placeholder]="t('form.short_description')" [innerHTML]="t('form.message_textarea')"></textarea>
              <div [hidden]="(messageInput.valid || messageInput.pristine)" class="mt-1"><span class="text-red-500">{{
                  t('form.field_required') }}</span></div>
            </div>
          </div>
          <p class="mt-2"
            [innerHTML]="t('form.privacy_tos', {link_cookie_policy: config?.link_cookie_policy, link_terms_condition: config?.link_terms_condition})">
          </p>
          <div class="flex flex-row justify-content-end align-items-center mt-2">
            <p-button [label]="t('form.send_message')" [disabled]="!form.valid" [attr.aria-disabled]="!form.valid"
              [loading]="loading" (onClick)="sendContactForm()" (keyup.enter)="sendContactForm()" type="submit"></p-button>
            <p-button class="ml-2" severity="secondary" [label]="t('close')" (onClick)="contactModalVisible = false"
              (keyup.enter)="contactModalVisible = false"></p-button>
          </div>
        </form>
      }
    </p-dialog>
  }
</ng-container>